export default __webpack_public_path__ + "static/media/Tunic of the Firebrand.95ec6249.jpg";